import isServer from './isServer';
import isNewConsumerApp from './isNewConsumerApp';

let clientIPExperimental = null;

setTimeout(async () => {
  if (isServer()) {
    return;
  }
  try {
    if (isNewConsumerApp) {
      const response = await fetch('/fe-api/client-ip', {
        method: 'GET',
      });

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      clientIPExperimental = data?.ip || null;
    } else {
      // Legacy fallback for the old consumer app.
      const response = await fetch('https://1.1.1.1/cdn-cgi/trace', {
        method: 'GET',
      });

      if (!response.ok) {
        return;
      }

      const body = await response.text();
      const cipe = body
        .split('\n')
        .find(line => line.indexOf('ip=') === 0)
        ?.split('=')[1];

      clientIPExperimental = cipe || null;
    }
  } catch (err) {
    /* ignore */
  }
}, 5000);

const getClientIPExperimental = () => clientIPExperimental;

export default getClientIPExperimental;
